module.exports = __webpack_public_path__ + "img/result.e23b1be6.jpg";